import { Link } from 'react-router-dom';
import type { Movie } from '@/types/content';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-md"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}封面`}
          title={`${movie.title} - 红杏影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-accent-400">
          <i className="ri-star-fill text-[11px]" />
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-foreground-950/90 to-transparent px-3 py-3 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">{movie.summary}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950">{movie.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}